import ControleDetailController from './controle.detail.controller';

export default {
    template: require('./controle.detail.html'),
    controller: ControleDetailController
};
